import * as ActionTypes from './actionTypes'
import {saveShipmentDetail ,addAIInfo, addAddInfo ,saveAIStatementAndCodesInfo } from '../api/saveC88Data'
import {deleteAIStatementAndCodeInfoHeader} from '../api/deleteC88Data'
import {showToast} from '../../commonComponents/showToast'
import { HttpClient } from '../../../commonApis/httpClient'


export function  updateHeaderAIStatementInfoFeilds(infoIndex, infoField, payload){
    return {
        type: ActionTypes.UPDATE_AI_STATEMENT_INFO_FIELDS,
        payload,
        infoIndex,
        infoField   
    }
}

export function deleteHeaderAIStatementAndCodeInfo(infoId,infoIndex,deleteInfoStatus){
    return(dispatch, getState)=>{
        
        deleteAIStatementAndCodeInfoHeader(getState().Shipment.shipmentId,infoId)
        .then(response => {
           dispatch({
                type: ActionTypes.DELETE_AI_STATEMENT_AND_CODES_INFO_HEADER,
                infoIndex
            })
            deleteInfoStatus()
            console.log(response)
        })
        .catch(error => {
            
            console.error(`Error in removeLineItemInfo : `, error)
            showToast("Something went wrong, Check your network connection!");
            deleteInfoStatus();
        })
    }
}


export function createAdditonalInfo(addInfoStatus){
    return (dispatch, getState) => {
        let dataSent = addAddInfo()
        HttpClient.post(dataSent)
            .then(response => {
                if(response.data.eventMessage.code !== 400){
                let payload = response.data.eventMessage
                dispatch({
                    type: ActionTypes.ADD_ADDITONAL_INFO,
                    payload
                })
               
            }
            addInfoStatus()
            }).catch(error => {
                console.log("ERROR:: " + error);
                showToast("Something went wrong, Check your network connection!");
                addInfoStatus();
            })
    }
}

export function createAICodeAndStatementnfo(addInfoStatus){
    return (dispatch, getState) => {
        let dataSent = addAIInfo()
        HttpClient.post(dataSent)
            .then(response => {
                if(response.data.eventMessage.code !== 400){
                let payload = response.data.eventMessage
                dispatch({
                    type: ActionTypes.ADD_AI_CODES_AND_STATEMENT_INFO,
                    payload
                })
            }
                addInfoStatus()
            
            }).catch(error => {
                console.log("ERROR:: " + error);
                showToast("Something went wrong, Check your network connection!");
                addInfoStatus();
            })
    }
}




 

export function saveAIInfoFeilds(infoIndex, fieldName) {
    return (dispatch, getState) => {
        let lineItemInfo = getState().Shipment.aiStatementUkInfo[infoIndex]
        let fieldValue =lineItemInfo[fieldName] === "" ? '_BLANK_' :lineItemInfo[fieldName]
        let response = saveAIStatementAndCodesInfo(lineItemInfo.infoId, fieldName,fieldValue);
        console.log(response)
    }
}

// containers start

export function createContainerHeader(addInfoStatus){
    return (dispatch, getState) => {
        let dataSent = addAIInfo()
        HttpClient.post(dataSent)
            .then(response => {
                if(response.data.eventMessage.code !== 400){
                let payload = {containerNo : "",seal:"",qty:"",weight :"",size :"",infoId:response.data.eventMessage.infoId}
                dispatch({
                    type: ActionTypes.ADD_ITEM,
                    payload,
                    meta:{tableName:"headerContainer"}

                })
            }
                addInfoStatus()
            
            }).catch(error => {
                console.log("ERROR:: " + error);
                showToast("Something went wrong, Check your network connection!");
                addInfoStatus();
            })
    }
}
export function deleteContainerHeader(id){
    return(dispatch, getState)=>{
        
        deleteAIStatementAndCodeInfoHeader(getState().Shipment.shipmentId,id)
        .then(response => {console.log("11111111",id)
           dispatch({
                type: ActionTypes.DELETE_ITEM,
                id,
                meta:{tableName:"headerContainer"}
            })
           
            
        })
        .catch(error => {
            dispatch({
                type: ActionTypes.DELETE_ITEM,
                id,
                meta:{tableName:"headerContainer"}
            })
            console.error(`Error in removeLineItemInfo : `, error)
            showToast("Something went wrong, Check your network connection!");
           
        })
    }
}
export const updateContainerHeader=(id,fieldName,val)=>{
    return{
        type:ActionTypes.UPDATE_ITEM,
        id,
        fieldName,
        val,
        meta:{tableName:"headerContainer"}
    }
}

// containers end